import AddressMainText from '@porterin/booking-flow/src/order-review/view/components/AddressMainText';
import AddressSecondaryText from '@porterin/booking-flow/src/order-review/view/components/AddressSecondaryText';
import { OrderReviewAssets } from '@porterin/booking-flow/src/order-review/view/stores/OrderReviewStore';
import Image from 'next/image';
import React from 'react';

export interface AddressPredictionItemProps {
  main_text: string;
  secondary_text: string;
  on_click: () => void;
}

const AddressPredictionItem: React.FC<AddressPredictionItemProps> = ({
  main_text,
  secondary_text,
  on_click,
}) => (
  <div
    className="py-2 flex items-center border-b last:border-b-0 cursor-pointer hover:bg-[#f3f3f3]"
    onClick={() => on_click()}
  >
    <div className="p-[0.8rem_0] flex">
      <Image
        height={24}
        width={24}
        src={OrderReviewAssets.mapPin.src}
        alt={OrderReviewAssets.mapPin.alt}
        quality={70}
      />
    </div>
    <div className="ml-[0.4rem] border-b-[0.1rem] border-[#f2f2f2] last:border-b-0 p-[0.8rem]">
      <AddressMainText text={main_text} id="address-main-text" />
      <AddressSecondaryText text={secondary_text} id="address-sec-text" />
    </div>
  </div>
);

export default AddressPredictionItem;
